import type { LegDTO } from '@/types/dto/agent';
import { formatDay, formatTime, stripTimeZoneOffset } from '@/utils/dateTime';
import { Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

const LegDateTime: FC<{ dateTime: LegDTO['departureTime'] }> = ({
  dateTime,
}) => (
  <div className="flex flex-row gap-2">
    <Typography variant="body2" className="text-neutral">
      {dateTime && formatDay(stripTimeZoneOffset(dateTime))}
    </Typography>
    <Typography variant="body2" className="text-medium">
      {formatTime(dateTime)}
    </Typography>
  </div>
);

export default LegDateTime;
